//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {
      options: [],

      isOpen: false,
      isLoading: true,
    }
  },

  computed: {
    selectedTitle: function () {
      return this.value?.name || "Выберите специалиста"
    }
  },

  props: {
    value: {},

    selectedAge: {},
    selectedSalon: {},
    selectedService: {},
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        window.addEventListener('click', this.eventClick, true);
      } else {
        window.removeEventListener('click', this.eventClick, true);
      }
    }
  },

  methods: {
    changeOpen: async function (value) {
      this.isOpen = value;
      if (value && this.isLoading) {
        await this.getOptions();
      }
    },
    changeOption: function (option) {
      this.$emit("change", option);
      this.changeOpen(false);
    },

    getOptions: async function () {
      const filterAge = Boolean(this.selectedAge === "19") ? "filter[for_not_children]=1" : `filter[for_children_${(this.selectedAge || "").replace("-", "_")}]=1`;
      const search = `${ filterAge }&filter[service_id]=${this.selectedService}${ Boolean(String(this.selectedSalon) === "-1") ? '' : `&filter[store_id]=${this.selectedSalon}` }`;
      const action = Boolean(String(this.selectedSalon) === "-1") ? '/specialist' : '/specialist/available';

      let options = await this.$api.agent.transport.get(`${ action }?expand=stores&${ search }`)
        .then((res) => res?.data || [])
        .catch(() => []);
      this.options = [
        {name: "Любой специалист", id: -1},
        ...options
      ];
      this.isLoading = false;
    },

    eventClick: function (event) {
      if (event.target.closest('.specialist-select')) {
        return
      }
      this.changeOpen(false);
    },
  }
}
